import gql from 'graphql-tag'

export const GET_INSTRUCTOR_HOURS = gql`
  query GetInstructorHours(
    $StartDateTime: String!
    $EndDateTime: String!
    $LearningCenterId: String!
    $InstructorId: String!
  ) {
    getInstructorHours(
      StartDateTime: $StartDateTime
      EndDateTime: $EndDateTime
      LearningCenterId: $LearningCenterId
      InstructorId: $InstructorId
    ) {
      instructorHoursInfo {
        MaxDailyHours
        InstructorId
        HoursInARow
        MinimumBreakLength
        DailyHoursInfo {
          StartDateTime
          EndDateTime
          DailyHours
          DailyHoursRemaining
        }
      }
    }
  }
`
